export default "__VITE_ASSET__BVzSM3Cy__"